import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { getDummyText } from "../../utils";

interface TemplateArgs {
    download?: string | undefined;
    fileInfo?: string | undefined;
    link: string;
    linkText?: string | undefined;
    tags?: string | undefined;
    exampleTitle?: string | undefined;
    exampleDescription?: string | undefined;
    exampleImage?: string | undefined;
}

const exampleTile: TemplateArgs = {
    link: "./mock-assets/images/downloads/example-122x172.png",
    linkText: "Download",
    tags: "Whitepaper",
    exampleTitle: getDummyText(60),
    exampleDescription: getDummyText(240),
    exampleImage: "./mock-assets/images/downloads/example-122x172.png",
};

export const exampleTiles: TemplateArgs[] = [
    {
        ...exampleTile,
        exampleTitle: getDummyText(30),
        exampleDescription: getDummyText(240),
        exampleImage: "./mock-assets/images/comparison.jpg",
    },
    {
        ...exampleTile,
        download: "example.pdf",
        fileInfo: "PDF 460 kB",
        exampleTitle: getDummyText(60),
        exampleDescription: getDummyText(40),
    },
    {
        ...exampleTile,
        download: "example.pdf",
        tags: "PDF",
        fileInfo: "25.01.2025",
        exampleTitle: getDummyText(400),
        exampleDescription: getDummyText(100),
        exampleImage: "./mock-assets/images/contact-personx2.png",
    },
    {
        ...exampleTile,
        exampleTitle: getDummyText(60),
        exampleDescription: getDummyText(40),
        exampleImage: "./mock-assets/images/contact-personx2.png",
    },
];

export const TeaserDownloadTileTemplate = ({
    download,
    fileInfo,
    link,
    linkText = "Download",
    tags,
    exampleTitle = "",
    exampleDescription = "",
    exampleImage = "",
}: TemplateArgs) =>
    html` <ux-iws-teaser-download-tile
        download=${ifDefined(download)}
        file-info=${ifDefined(fileInfo)}
        link=${ifDefined(link)}
        link-text=${ifDefined(linkText)}
        tags=${ifDefined(tags)}
    >
        ${exampleImage &&
        html`
            <div slot="image">
                <img
                    src="${exampleImage}"
                    alt="Image Alt Text"
                    width="122"
                    height="172"
                />
            </div>
        `}
        ${exampleTitle &&
        html`<h4 slot="title" class="ux-text-title ux-text-title--bold">
            ${exampleTitle}
        </h4>`}
        ${exampleDescription &&
        html`
            <p class="ux-text-normal" slot="description">
                ${exampleDescription}
            </p>
        `}
    </ux-iws-teaser-download-tile>`;

export const TeaserDownloadTileGridTemplate = () => html`
    <div class="ux-iws-teaser-download-tile-grid">
        ${exampleTiles.map((item) => TeaserDownloadTileTemplate(item))}
    </div>
`;
